module.exports = __webpack_public_path__ + "img/3-1.2d15737a.jpg";